import React, { useState, useEffect, useContext } from 'react';
import { getAllUsers, adminUpdateUser } from '../../services/UserServices';
import AuthContext from '../../context/AuthContext';
import styles from './styles/AdminUserPage.module.css'
import SearchBar from '../common/SearchBar';

const AdminUserPage = () => {
    const { user: yourUser, getLoggedIn } = useContext(AuthContext);
    const [allUsers, setAllUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);

    useEffect(() => {
        const fetchUsers = async () => {
            const users = await getAllUsers();
            setAllUsers(users);
        };
        fetchUsers();
    }, []);

    const handleUpdate = async (userId, info) => {
        try {
            // Use the SECURE admin route
            const updatedUser = await adminUpdateUser(userId, info);

            setAllUsers(prev => prev.map(u => u._id === userId ? updatedUser : u));

            if (userId === yourUser.id) {
                await getLoggedIn();
            }
        } catch (err) {
            alert(err.response?.data?.errorMessage || "Failed to update user");
        }
    };
    


    return (
        <div className={styles.container}>
            <div>
                <SearchBar type={'users'} setter={setSelectedUserId}/>
            </div>
            <div className={styles.userList}>
                {allUsers.map(user => {
                    if (selectedUserId && selectedUserId._id !== user._id) return null;


                    return (
                        <div key={user._id} className={styles.userCard}>
                        <div className={styles.userInfo}>
                            <p className={styles.username}>{user.username}</p>
                            <p className={styles.email}>{user.email}</p>
                        </div>
                        <div className={styles.actions}>
                                {yourUser.tier >= user.tier && (
                                    <>
                                        <button onClick={() => handleUpdate(user._id, { banned: !user.banned })}>
                                            {user.banned ? 'Unban' : 'Ban'}
                                        </button>
                                        <button onClick={() => handleUpdate(user._id, { verified: !user.verified })}>
                                            {user.verified ? 'Unverify' : 'Verify'}
                                        </button>
                                    </>
                                )}

                                {yourUser.tier <= user.tier ? (
                                    <div className={styles.tierLabel}>
                                        {user.tier === 0 ? 'Basic' : user.tier === 1 ? 'Pro' : user.tier === 2 ? 'Admin' : 'Owner'}
                                    </div>
                                ) : (
                                    <select
                                        value={user.tier}
                                        onChange={(e) => handleUpdate(user._id, { tier: parseInt(e.target.value) })}
                                    >
                                        {Array.from({ length: yourUser.tier + 1 }, (_, i) => i).map(t => (
                                            <option key={t} value={t}>
                                                {t === 0 ? 'Basic' : t === 1 ? 'Pro' : t === 2 ? 'Admin' : 'Owner'}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AdminUserPage


//list of all the users (options to manually verify and unverify user accounts), ability to promote admins, 

// classroom creation, scenario collaboration, scenario logs, max scenarios, 